export const sortedRecipesHelper = (
  value,
  filteredRecipes,
  recipeOrdering
) => {
  const recipeArr = filteredRecipes;
  let sortedRecipes;
  switch (value) {
    case "recommended": {
      const uniqueReciOrdering = [...new Set(recipeOrdering)];

      const recommendedRecipeList = uniqueReciOrdering
        ?.map((id) => {
          return recipeArr.find((r) => r.id === id);
        })
        .filter((r) => r);

      const recommendedRecipeListIds = recommendedRecipeList.map((r) => r.id);

      sortedRecipes = [...recommendedRecipeList].concat(
        recipeArr.filter((r) => !recommendedRecipeListIds?.includes(r.id))
      );
      break;
    }
    case "time": {
      sortedRecipes = [...recipeArr].sort((recipeA, recipeB) => {
        const cookTimeA = recipeA.metadata.cookingTime;
        const cookTimeB = recipeB.metadata.cookingTime;

        return cookTimeA - cookTimeB;
      });
      break;
    }
    case "ascending": {
      const alphabeticOrderedRecipe = [...recipeArr].sort((recipeA, recipeB) =>
        recipeA.metadata.name.localeCompare(recipeB.metadata.name)
      );
      sortedRecipes = alphabeticOrderedRecipe;
      break;
    }
    default:
      sortedRecipes = recipeArr;
  }
  return sortedRecipes;
};